<template>
	<div>
		<div class="wrap">
			<Title title="LG圆满假期222">
				<div class="title-more" slot="title-more">
					<el-button type="warning" size="mini">开启投票</el-button>
				</div>
			</Title>
			<el-table border :data="tableData" style="width: 100%">
				<el-table-column prop="name" label="名称" height="30">
				</el-table-column>
				<el-table-column prop="voteTime" label="投票时间">
				</el-table-column>
				<el-table-column prop="username" label="投票人">
				</el-table-column>
				<el-table-column prop="publicStatus" label="发布状态">
				</el-table-column>
				<el-table-column prop="addTime" label="发布时间">
				</el-table-column>
				<el-table-column prop="beginStatus" label="启动状态">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope"></template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage4"
				:page-sizes="[100, 200, 300, 400]"
				:page-size="100"
				layout="total, sizes, prev, pager, next, jumper"
				:total="4">
				</el-pagination>
			</div>
		</div>
		<div class="wrap">
			<Title title="参选者详情"></Title>
			<el-table border :data="tableData2" style="width: 100%">
				<el-table-column prop="voteId" label="投票号" height="30">
				</el-table-column>
				<el-table-column prop="name" label="姓名">
				</el-table-column>
				<el-table-column prop="school" label="学校">
				</el-table-column>
				<el-table-column prop="voteNum" label="票数">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	export default {
		name: 'Selection',
		components: {
			Title
		},
		data() {
			return {
				tableData: [{
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布',
					addTime: '2016-05-02',
					beginStatus: '已启动'
				}, {
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布',
					addTime: '2016-05-02',
					beginStatus: '已启动'
				}, {
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布',
					addTime: '2016-05-02',
					beginStatus: '已启动'
				}, {
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布',
					addTime: '2016-05-02',
					beginStatus: '已启动'
				}],
				tableData2: [{
					voteId: '2982828',
					name: '张三三',
					school: '北京邮电大学',
					voteNum: '30'
				}, {
					voteId: '2982828',
					name: '张三三',
					school: '北京邮电大学',
					voteNum: '30'
				}, {
					voteId: '2982828',
					name: '张三三',
					school: '北京邮电大学',
					voteNum: '30'
				}]
			}
		},
		methods: {

		}
	}
</script>

<style scoped lang="less">
	.wrap /deep/ .el-table .el-table__cell {
		padding: 6px 0 !important;
		font-size: 12px;
	}

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	.pagination{
		margin-top: 10px;
	}
	.title /deep/ .el-button--warning{
		background-color: #EB6B1B
	}
	.title /deep/ .el-button--mini{
		padding: 4px 10px;
	}
</style>